export const VARIANT_CHEVRON_SIZE = '1.5rem';
export const COLOR_CIRCLE_SIZE = 2.25;
